<template>
    <div class="last-products">
        <div class="container">
            <h2 class="section-title fw-bold text-center ">
                <img src="@/assets/home/box.png" style="width: 50px;height: 50px;margin-left: 0.5rem;" alt="">
                 <span>الاقسام</span>
            </h2>
            <div class="products-container container">
                <LoadingComponent v-if="is_loading" />
                <template  v-else>
                    <CategoryBoxComponent  v-for="(product,index) in products" :key="index" :data="product" />
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import config from '@/services/config';
import LoadingComponent from '../Loading/LoadingComponent.vue';
import CategoryBoxComponent from '../CategoryBox/CategoryBoxComponent.vue';
export default {
    name: 'LastProductComponent' ,
    components: {
        CategoryBoxComponent ,
        LoadingComponent,
    }, 
    data(){
        return {
            products: [] ,
            is_loading: true
        }
    },
    created() {
        this.get_products()
    },
    methods: {
        get_products() {
            axios.get(`${config.basURL}categories/`)
            .then(res => {
                console.log(res.data)
                this.products = res.data.results
            })
            .catch(err => {
                console.log(err)
            }).finally(() => {
                this.is_loading = false
            })
        }
    }
}
</script>
<style scoped>
.products-container {
    display: flex;
    flex-wrap: wrap;
}
::v-deep(.products-container .product-box) {
    width: calc(100% / 3 - 3rem);
}

@media(max-width: 767px) {
    ::v-deep(.products-container .product-box) {
    width: 100%;
}
.more-products {
    width: 100%;
}
}
.more-products{
    all: unset ;
    padding: 0.5rem 1.5rem;
    font-size: 1.2rem;
    font-weight: bold;
    border-radius: 5px;
    cursor: pointer;
    border: 1px solid #2c3e50;
    color: #2c3e50;
    background-color: #FF7070;
    transition: all 0.5s;
}
.more-products:hover {
    opacity: 0.8;
}
</style>